import React from "react";
import { Navigate, Route } from "react-router-dom";

import { IAuthUser } from "../interfaces/IAuthUser";
import { Collector } from "../pages/collector/Collector";
import { CollectorPlant } from "../pages/collectorPlant/CollectorPlant";
import { CollectorPlants } from "../pages/collectorPlants/CollectorPlants";
import { ExhibitionsJudges } from "../pages/exhibitionsJudges/ExhibitionsJudges";
import { Home } from "../pages/home/Home";
import { Reception } from "../pages/reception/Reception";
import { User } from "../pages/user/User";

interface SharedRoutesProps {
  user: IAuthUser | null;
}

export const SharedRoutes: React.FC<SharedRoutesProps> = ({ user }) => {
  return (
    <>
      <Route
        path="/home"
        element={
          user ? (
            user.typeId === 2 ? (
              <ExhibitionsJudges pageTitle="Julgamento | Exposições" />
            ) : (
              <Home />
            )
          ) : (
            <Navigate to="/" />
          )
        }
      />

      <Route
        path="/profile"
        element={
          user && user.typeId !== 1 ? (
            <User pageTitle="Julgamento | Meu Perfil" />
          ) : (
            <Navigate to="/" />
          )
        }
      />

      <Route
        path="/collector"
        element={<Collector pageTitle="Julgamento | Colecionador" />}
      />

      <Route
        path="/collector/:id"
        element={<Collector pageTitle="Julgamento | Colecionador" />}
      />

      <Route
        path="/collector-plants/:exhibitionId/:collectorId"
        element={<CollectorPlants pageTitle="Julgamento | Minhas Plantas" />}
      />

      <Route
        path="/collector-plant/:id"
        element={<CollectorPlant pageTitle="Julgamento | Planta" />}
      />

      <Route
        path="/collector-plant"
        element={<CollectorPlant pageTitle="Julgamento | Planta" />}
      />

      <Route
        path="/received/exhibition/:exhibitionId"
        element={
          user && (user.typeId === 1 || user.typeId === 4) ? (
            <Reception pageTitle="Julgamento | Mesa de Recepção" />
          ) : (
            <Navigate to="/" />
          )
        }
      />
    </>
  );
};
